import { Menu } from '@mantine/core';
import { fetchApiExportEntity } from '@repo/api-codegen';
import { Icon } from '@repo/foundations';
import { useCallback } from 'react';
import type { ISecodaEntity } from '../../../../api';
import type { SecodaEntity } from '../../../../lib/models';
import { useBackgroundJob2 } from '../../../BackgroundJobProgress/BackgroundJob2.hooks';

interface ExportActionProps {
	entity: SecodaEntity | ISecodaEntity;
}

export function ExportAction({ entity }: ExportActionProps) {
	const [startJob] = useBackgroundJob2(
		undefined,
		'Entity Export Completed',
		true
	);

	const handleJSONExportClick = useCallback(async () => {
		try {
			const response = await fetchApiExportEntity({
				pathParams: { entityId: entity.id },
				queryParams: {
					export_type: 'json',
					include: 'direct_children',
				},
			});

			if (response.id) {
				await startJob(response.id, 'resources.json');
			}
		} catch (error) {
			throw error;
		}
	}, [entity, startJob]);

	const handleCSVExportClick = useCallback(async () => {
		try {
			const response = await fetchApiExportEntity({
				pathParams: { entityId: entity.id },
				queryParams: {
					export_type: 'csv',
					include: 'direct_children',
				},
			});

			if (response.id) {
				await startJob(response.id, 'resources.csv');
			}
		} catch (error) {
			throw error;
		}
	}, [entity, startJob]);

	const handlePrintClick = useCallback(() => {
		try {
			// @ts-expect-error - document.execCommand is deprecated, used in Safari
			if (!document.execCommand('print', false, null)) {
				window.print();
			}
		} catch {
			window.print();
		}
	}, []);

	return (
		<>
			<Menu.Item icon={<Icon name="csv" />} onClick={handleCSVExportClick}>
				Export CSV
			</Menu.Item>
			<Menu.Item icon={<Icon name="json" />} onClick={handleJSONExportClick}>
				Export JSON
			</Menu.Item>
			<Menu.Item icon={<Icon name="pdf" />} onClick={handlePrintClick}>
				Export PDF
			</Menu.Item>
		</>
	);
}
